import api from './api';

export async function getVenueCourts(venueId) {
  const response = await api.get(`/venues/${venueId}/courts`);
  return response.data;
}

export async function createCourt(venueId, data) {
  const response = await api.post(`/venues/${venueId}/courts`, data);
  return response.data;
}

export async function updateCourt(courtId, data) {
  const response = await api.put(`/courts/${courtId}`, data);
  return response.data;
}

export async function updateCourtOrder(venueId, courtIds) {
  await api.put(`/venues/${venueId}/courts/order`, { courtIds });
}

export async function deleteCourt(courtId) {
  const response = await api.delete(`/courts/${courtId}`);
  return response.data;
}

export async function blockCourt(courtId, data) {
  const response = await api.post(`/courts/${courtId}/block`, data);
  return response.data;
}

export async function unblockCourt(courtId, data) {
  const response = await api.post(`/courts/${courtId}/unblock`, data);
  return response.data;
}

export async function getBlockedSlots(venueId, fromDate, toDate) {
  const response = await api.get(`/venues/${venueId}/blocked-slots`, {
    params: { fromDate, toDate },
  });
  return response.data;
}

export async function deleteBlockedSlot(blockedSlotId) {
  const response = await api.delete(`/blocked-slots/${blockedSlotId}`);
  return response.data;
}
